var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_404"},[_c('h2',{staticClass:"m-0"}),_c('img',{attrs:{"src":require("../assets/images/404.png"),"alt":"页面未找到"}}),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.goHome}},[_vm._v("返回首页")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }